module.exports = __webpack_public_path__ + "citi.2e2702ad1775b84fb10aac5213067dc0.svg";